module.exports = __webpack_public_path__ + "static/media/indus2.e9cc6533.jpeg";